export default "__VITE_ASSET__BhVDh$Lh__"